import api from '../api'
import { UsuarioRepository } from './usuario-repository'

export * from './tipo-usuario'
export * from './usuario'
export * from './usuario-repository'

export const usuario_repository = new UsuarioRepository(api)